<template>
  <!-- 全屏弹窗容器 -->
  <van-popup 
    v-model="visible" 
    class="full-screen-popup" 
    position="right" 
    :close-on-click-overlay="false"
    get-container="body"
  >
    <div class="page-container">
      
      <!-- 1. 顶部导航栏 -->
      <div class="nav-header">
          <van-icon name="arrow-left" class="nav-back" @click="onClose" />
          {{ title }}
      </div>

      <!-- 内容滚动区 -->
      <div class="scroll-content">
        <van-skeleton title :row="10" :loading="loading" style="margin-top:20px">
          
          <!-- 1. 个人信息 -->
          <div class="form-card">
              <div class="section-title"><van-icon name="idcard" /> 个人信息</div>
              <!-- 性别选择 (大按钮风格) -->
              <div class="gender-selector">
                  <div :class="['gender-opt', customerInfoData.sex==='MALE'?'active-m':'']" @click="customerInfoData.sex='MALE'">
                      <van-icon name="manager" /> 男 Male
                  </div>
                  <div :class="['gender-opt', customerInfoData.sex==='FEMALE'?'active-f':'']" @click="customerInfoData.sex='FEMALE'">
                      <van-icon name="manager" /> 女 Female
                  </div>
              </div>

              <van-field 
                v-model="customerInfoData.loaclName" 
                left-icon="manager-o" 
                label="中文姓名" 
                placeholder="与证件一致" 
                required
                @blur="onLocalNameBlur"
              />
              <van-field v-model="customerInfoData.lastName" left-icon="edit" label="拼音(姓)" placeholder="Surname (e.g. ZHANG)" required />
              <van-field v-model="customerInfoData.firstName" left-icon="edit" label="拼音(名)" placeholder="Given Name (e.g. SAN)" required />
              <van-field 
                readonly 
                clickable 
                :value="customerInfoData.birthday ? formatDate(customerInfoData.birthday, 'yyyy-MM-dd') : ''" 
                left-icon="notes-o" 
                label="出生日期" 
                placeholder="点击选择" 
                @click="showCalendar = true" 
                class="din-font" 
                required 
              />
              <div class="tip-text"><van-icon name="info-o" style="margin-right:2px" /> 如需修改姓名、生日，请联系客服。</div>
          </div>

          <!-- 2. 潜水证书与绑定信息 -->
          <div class="form-card">
              <div class="section-title"><van-icon name="manager-o" /> 联络信息</div>
              


              <!-- 仅保留护照号码 -->
              <van-field v-model="customerInfoData.passportNumber" v-if="baseSystem ==='cooldive'"  left-icon="notes-o" label="护照号码" placeholder="请填写护照号码" class="din-font" required />

              <van-field v-model="customerInfoData.idCardNumber" v-if="baseSystem !=='cooldive'" left-icon="notes-o" label="身份证号码" placeholder="请填写身份证号码" class="din-font" required />

              <van-field v-model="customerInfoData.email" left-icon="envelop-o" label="电子邮箱" placeholder="用于接收电子证书" required />
              <van-field v-model="customerInfoData.guardianEmail" left-icon="envelop-o" label="监护人邮箱" placeholder="未满18必须填写监护人邮箱"/>
              <van-field v-model="customerInfoData.phone" left-icon="phone-o" label="手机号码" type="tel" class="din-font" required />
              
          </div>

          <!-- 3. 潜水装备尺码 (网格布局) -->
          <div class="form-card">
              <div class="section-title"><van-icon name="chart-trending-o" /> 潜水装备尺码</div>
              <div class="stats-grid">
                  <div class="stat-item">
                      <div class="stat-label required"><van-icon name="bar-chart-o" /> 身高 (cm)</div>
                      <input type="number" class="stat-input" v-model="customerInfoData.height" placeholder="0">
                  </div>
                  <div class="stat-item">
                      <div class="stat-label required"><van-icon name="aim" /> 体重 (kg)</div>
                      <input type="number" class="stat-input" v-model="customerInfoData.weight" placeholder="0">
                  </div>
                  <div class="stat-item">
                      <div class="stat-label required"><van-icon name="apps-o" /> 鞋码 (EU)</div>
                      <input type="number" class="stat-input" v-model="customerInfoData.shoeSize" placeholder="0">
                  </div>
              </div>
          </div>

          <!-- 4. 潜水组织与等级 (切换逻辑) -->
          <div class="form-card">
              <div class="section-title"><van-icon name="award-o" /> 潜水组织与等级</div>
              <div class="exp-toggle">
                  <div :class="['toggle-btn', diverType==='student'?'active':'']" @click="diverType='student'">我在考证</div>
                  <div :class="['toggle-btn', diverType==='certified'?'active':'']" @click="diverType='certified'">持证潜水员</div>
              </div>
              <!-- 仅当持证时显示 -->
              <div v-if="diverType==='certified'">
                  <van-field v-model="customerInfoData.nowLicense" left-icon="medal-o" label="当前等级" placeholder="如 PADI AOW" required />
                  <van-field v-model="customerInfoData.totalDiving" left-icon="wap-nav" label="潜水次数" type="digit" class="din-font" required />
                  <van-field v-model="customerInfoData.lastDiveDate" left-icon="clock-o" label="最后潜水" placeholder="如 2023年10月" class="din-font" required />
              </div>
          </div>

          <!-- 5. 紧急联系人 -->
          <div class="form-card">
              <div class="section-title"><van-icon name="phone-circle-o" /> 紧急联系人</div>
              <van-field v-model="customerInfoData.emergencyName" left-icon="friends-o" label="联系人姓名" placeholder="请输入" required />
              <van-field v-model="customerInfoData.emergencyContact" left-icon="phone-o" label="联系方式" placeholder="请输入" type="tel" class="din-font" required />
          </div>

          <!-- 6. 潜水保险 (UI占位，数据暂不提交) -->
          <div class="form-card" v-if="showType === 'student' && baseSystem==='cooldive'">
            <div class="card-header">
              <div class="card-title"><van-icon name="orders-o" /> 潜水保险</div>
              <div class="card-action" @click="onBuyInsurance()">购买保险</div>
            </div>

            <div class="exp-toggle1">
              <div :class="['toggle-btn', customerInfoData.insuranceOrderId===''?'active':'']" @click="customerInfoData.insuranceOrderId=''">手动上传保险</div>

              <div v-for="insurance in insuranceList" :key="insurance.order.insuranceOrderId" 
                :class="['toggle-btn', customerInfoData.insuranceOrderId===insurance.order.insuranceOrderId?'active':'']" @click="customerInfoData.insuranceOrderId=insurance.order.insuranceOrderId">
                {{insurance.order.productName}}<br>
                {{ insurance.orderInfo.deadlineText }} {{ GetEnumText('Em_IssueStatus',insurance.order.issueStatus) }}</div>
            </div>


              <template v-if="customerInfoData.insuranceOrderId===''">
                <!-- 暂存到临时字段，不校验必填 -->
                <van-field v-model="customerInfoData.insuranceComplane" left-icon="shop-o" label="保险公司" placeholder="请输入" required/>
                <van-field v-model="customerInfoData.insuranceCode" left-icon="orders-o" label="保单号" placeholder="请输入" class="din-font" required/>
                <van-field v-model="customerInfoData.insurancePhone" left-icon="phone-o" label="联系电话" placeholder="请输入" type="tel" class="din-font" required/>
                
                <div style="padding: 10px 16px 5px 16px;">
                    <div style="font-size:12px; color:#6B7280; margin-bottom:10px; display:flex; align-items:center; gap:4px">
                        <van-icon name="description" /> 保单文件
                    </div>
                    <div style="display:flex; gap:16px">
                        <!-- 点击仅提示，不触发动作 -->
                        <van-uploader v-model="fileInsuranceList" :max-count="1" accept="image/*" :after-read="afterReadInsurance">
                          <div class="upload-mini-box"><van-icon name="photograph" size="24" color="#9CA3AF" /><span>图片</span></div>
                        </van-uploader>
                        <van-uploader v-model="fileInsurancePdfList" :max-count="1" accept=".pdf" :after-read="afterReadInsurancePDF" class="ml-2">
                          <div class="upload-mini-box"><van-icon name="description" size="24" color="#9CA3AF" /><span>PDF</span></div>
                        </van-uploader>
                      
                    </div>
                </div>
              </template>

              <div class="tip-text blue">
                  <strong>特别提示：</strong>潜店提供的保险通常仅覆盖当地紧急医疗救治。根据目的地法规要求，参与潜水活动的人员须持有涵盖跨境医疗转运及归国治疗的综合潜水保险。
              </div>
          </div>

          <!-- 6.5. 认证信息 -->
          <div class="form-card" v-if="needCert">
              <div class="section-title"><van-icon name="manager" /> 认证信息</div>
              <van-field readonly clickable :value="countryName" left-icon="wap-home-o" label="国家/地区" placeholder="请选择" @click="onInitCountry(()=>{ showCountryPicker = true })" required>
                  <template #right-icon><van-icon name="arrow-down" /></template>
              </van-field>
              <van-field v-if="customerInfoData.country!=='CHN'" v-model="customerInfoData.city" left-icon="bag-o" label="城市(英文)" class="din-font" required />
              <van-field
                left-icon="flag-o" 
                v-if="customerInfoData.country==='CHN'"
                v-model="zip"
                required
                clearable
                label="地区"
                placeholder="选择省/市/区"
                readonly
                @click="selectArea"
              />

              <van-field v-model="customerInfoData.postalCode" left-icon="bag-o" label="邮政编码" class="din-font" required />
              <van-field v-model="customerInfoData.address" left-icon="location-o" label="详细地址" type="textarea" rows="2" placeholder="街道门牌、楼层房间号等" required />
              <div class="tip-text red"><van-icon name="warning-o" /> 请填写准确以上信息，以免无法注册/查询证书</div>
          </div>

          <!-- 7. 认证照片 (复用旧裁剪逻辑) -->
          <div class="form-card" style="padding-bottom:24px"  v-if="needCert">
              <div class="section-title"><van-icon name="photograph" /> 认证照片</div>
              <div class="photo-wrapper">
                  <!-- 点击触发文件选择 -->
                  <div class="photo-slot" @click="triggerPhotoUpload">
                      <img v-if="option.img" :src="option.img" class="preview-img" />
                      <van-icon v-else name="manager" class="silhouette" />
                      <div class="camera-btn"><van-icon name="photograph" /></div>
                      <div v-if="option.img" class="reselect-mask">点击重选</div>
                  </div>
                  <!-- 隐藏的 input -->
                  <input type="file" ref="photoInput" accept="image/*" style="display:none" @change="onPhotoSelected">
                  
                  <div class="guide-row">
                      <div class="guide-item"><div class="guide-icon icon-no"><van-icon name="eye-o" style="text-decoration:line-through" /></div><span>无墨镜</span></div>
                      <div class="guide-item"><div class="guide-icon icon-no"><van-icon name="stop-circle-o" /></div><span>无遮挡</span></div>
                      <div class="guide-item"><div class="guide-icon icon-yes"><van-icon name="smile-o" /></div><span>正面清晰</span></div>
                  </div>
              </div>
          </div>
          
          <!-- 底部垫高 -->
          <div style="height: 80px;"></div>
        </van-skeleton>
      </div>

      <!-- 底部固定栏 -->
      <div class="bottom-bar">
          <button class="action-btn secondary" :disabled="buttonLoading" @click="onSaveDraft">保存草稿</button>
          <button class="action-btn primary" :disabled="buttonLoading" @click="onSubmit">提交保存</button>
      </div>

      <!-- 弹窗组件 -->
      <van-popup v-model="showCalendar" position="bottom"><van-datetime-picker type="date" title="选择生日" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmDate" @cancel="showCalendar=false" /></van-popup>
      <van-popup v-model="showCountryPicker" position="bottom"><van-picker show-toolbar :columns="countryList" @confirm="onConfirmCountry" @cancel="showCountryPicker=false" /></van-popup>

      <!-- 裁剪弹窗 (复用 VueCropper) -->
      <van-popup v-model="showCropper" :style="{ height: '100%', width: '100%' }" position="bottom">
          <div class="cropper-wrapper">
              <div class="cropper-content">
                <vueCropper
                  ref="cropper"
                  :img="cropperImg"
                  :output-size="option.size"
                  :output-type="option.outputType"
                  :info="true"
                  :full="option.full"
                  :can-move="option.canMove"
                  :can-move-box="option.canMoveBox"
                  :original="option.original"
                  :auto-crop="option.autoCrop"
                  :fixed="option.fixed"
                  :fixed-number="option.fixedNumber"
                  :center-box="option.centerBox"
                  :fixed-box="option.fixedBox"
                  :max-img-size="option.maxImgSize"
                  :enlarge="option.enlarge"
                />
              </div>
              <div class="cropper-footer">
                  <div class="crop-cancel" @click="showCropper=false">取消</div>
                  <div class="crop-tools" @click="rotateImg"><van-icon name="replay" /> 旋转</div>
                  <div class="crop-confirm" @click="onConfirmCrop">确认使用</div>
              </div>
          </div>
      </van-popup>
    <van-popup v-model="showAreaSelect" position="bottom">
      <van-area ref="pickerArea" :value="customerInfoData.zip==undefined?'110000':customerInfoData.zip.toString()" :loading="arealoading" :area-list="areaData" @confirm="confirmArea" @cancel="showAreaSelect=false" />
    </van-popup>
    </div>
  </van-popup>
</template>

<script>
import request from '@/utils/request'
import { Button, Field, Popup, Area, Uploader, Dialog, Picker, Skeleton, Icon, DatetimePicker, Toast } from 'vant'
import { formatDate,compressorImageList,  MyNotify,GetEnumText,GetBaseSystem } from '@/utils/base'
import { VueCropper } from 'vue-cropper'
import FieldSelect from '@/components/FieldSelect'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    [Picker.name]: Picker,
    [Skeleton.name]: Skeleton,
    [Icon.name]: Icon,
    [DatetimePicker.name]: DatetimePicker,
    VueCropper,
    FieldSelect
  },
  props: {
    value: undefined, // 接收 studentId
    showType: undefined,
    needCert: undefined,
  },
  data() {
    return {
      visible: false, // 控制 Popup 显示
      loading: true,
      buttonLoading: false,
      title: '编辑顾客信息',
      
      // 弹窗控制
      showCalendar: false,
      showCountryPicker: false,
      showCropper: false,
      
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(2050, 11, 31),

      id: undefined,
      customerInfoData: {
        loaclName: '', lastName: '', firstName: '', birthday: null,
        sex: 'MALE', 
        passportNumber: '', email: '', guardianEmail:'',phone: '', idCardNumber:'',
        country: 'CHN', zipString: '', postalCode: '', address: '',
        height: '', weight: '', shoeSize: '',
        nowLicense: '', totalDiving: '', lastDiveDate: '',
        emergencyName: '', emergencyContact: '',
        // 扩展字段
        insuranceComplane: '', insuranceCode: '', insurancePhone: '',insuranceOrderId:''
      },
      
      diverType: 'student', 
      countryList: [],
      fileInsuranceList: [],
      fileInsurancePdfList: [],
      // 裁剪相关
      cropperImg: '',
      changeUserHead: false,
      option: {
        img: '', // 最终预览图
        size: 0.8,
        outputType: 'jpeg',
        autoCrop: true,
        fixed: true,
        fixedNumber: [3, 4],
        centerBox: true,
        maxImgSize: 2000,
        enlarge: 1
      },
      insuranceList:[],
      baseSystem:undefined,
      showAreaSelect:false,
      areaData:undefined,
      arealoading:false,
      zip: undefined,
    }
  },
  computed: {
    countryName() {
      const c = this.countryList.find(i => i.value === this.customerInfoData.country);
      return c ? c.text : this.customerInfoData.country;
    }
  },
  watch: {
    // 监听 value 变化来打开弹窗
    value(val) {
      this.baseSystem= GetBaseSystem()
      console.log("打开信息页面:",this.needCert)
      if (val) {
        this.id = val;
        this.visible = true;
        this.init();
      } else {
        this.visible = false;
      }
    },
    // 监听 visible 关闭时，通知父组件重置 value
    visible(val) {
      if (!val) {
        this.$emit('input', null);
      }
    }
  },
  methods: {
    formatDate,
    GetEnumText,
    onClose() {
      this.visible = false;
    },
    confirmArea(selectList) {
      var title = ''
      var zipId = 0
      selectList.forEach(item => {
        title += item.name + ' '
        zipId = item.code
      })
      this.zip = title
      this.customerInfoData.zip = zipId
      this.showAreaSelect = false
    },
    selectArea() {
      this.showAreaSelect = true
      this.readAreaData()
    },
    readAreaData() {
      if (this.areaData !== undefined) {
        return
      }
      this.arealoading = true
      request({
        url: '/data/getArea',
        method: 'post'
      }).then(Response => {
        this.areaData = Response
        this.arealoading = false
      })
    },
    init() {
      this.loading = true;
      this.changeUserHead = false;
      this.option.img = '';
      this.loadInsurance();
      request({
        url: '/storeHelper/getBusinessCustomerInfo',
        method: 'post',
        data: { type: this.showType || 'normal', id: this.id }
      }).then(res => {
        this.loading = false;
        this.baseSystem= GetBaseSystem()
        if (!res.success) return;
        
        this.customerInfoData = res.data;
        this.zip = this.customerInfoData.zipString

        this.fileInsuranceList = []
        this.fileInsurancePdfList = []
        if(res.data.insuranceImage) {
          if(res.data.insuranceImage.toLowerCase().indexOf(".pdf") > 0) {
            this.fileInsurancePdfList.push({url: res.data.insuranceImage})
          } else {
            this.fileInsuranceList.push({url: res.data.insuranceImage})
          }
        }
        // 自动判断履历状态：有证书信息则为持证
        if (this.customerInfoData.nowLicense) {
          this.diverType = 'certified';
        } else {
          this.diverType = 'student';
        }
        
        // 头像回显
        if (this.customerInfoData.headIcon) {
          this.option.img = this.customerInfoData.headIcon;
        }
      });
    },
    loadInsurance() {
      this.insuranceList =[];
      request({
        url: '/divetrip/getDiveTripInsurance',
        method: 'post',
        data: {
          studentId: this.id,
          isGetList: true
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.insuranceList = response.data
        this.insuranceList.forEach(item => {
          item.orderInfo = JSON.parse(item.order.body)
        })
      })
    },

    onBuyInsurance(){
      let  t = Toast.success({
        duration: 0, 
        message: '正在保存草稿中...',
        forbidClick: true,
        loadingType: 'spinner'}
      );
      setTimeout(() => {
        this.saveData(false,()=>{
            t.clear();
            this.$router.push('/insurance/list?type=DiveStudent&diveType=All&studentId='+this.id)
        })
      }, 1000);
    },
    onInitCountry(callback) {
      if(this.countryList.length > 0) {
        if(callback) callback();
        return;
      }
      request({
        url: '/data/getCountryList',
        method: 'post'
      }).then(res => {
        if (res.success) {
          this.countryList = res.data.map(el => ({ text: el.name, value: el.code3 }));
          if (callback) callback();
        }
      });
    },

    // 交互逻辑
    onConfirmDate(val) {
      this.customerInfoData.birthday = formatDate(val, 'yyyy/MM/dd');
      this.showCalendar = false;
    },
    onConfirmCountry(item) {
      this.customerInfoData.country = item.value;
      this.showCountryPicker = false;
    },
    
    // 自动拼音
    onLocalNameBlur() {
      request({
        url: '/User/getNamePy',
        method: 'post',
        params: { name: this.customerInfoData.loaclName }
      }).then(Response => {
        if (Response.success) {
          this.customerInfoData.lastName = Response.data.lastName
          this.customerInfoData.firstName = Response.data.firstName
        }
      })
    },

    // 照片上传逻辑
    triggerPhotoUpload() {
      this.$refs.photoInput.click();
    },
    onPhotoSelected(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (evt) => {
        this.cropperImg = evt.target.result;
        this.showCropper = true;
      };
      reader.readAsDataURL(file);
      e.target.value = '';
    },
    rotateImg() {
      this.$refs.cropper.rotateRight();
    },
    onConfirmCrop() {
      this.$refs.cropper.getCropBlob((blob) => {
        const img = new Image();
        const reader = new FileReader();
        
        reader.onload = (e) => {
          img.onload = () => {
            // 创建canvas
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            // 限制最大400px
            let width = img.width;
            let height = img.height;
            const maxSize = 400;
            
            if (width > maxSize || height > maxSize) {
              const ratio = Math.min(maxSize / width, maxSize / height);
              width = width * ratio;
              height = height * ratio;
            }
            
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            
            // 转换为base64预览
            this.option.img = canvas.toDataURL('image/jpeg', 0.7);
            
            // 转换为blob用于上传
            canvas.toBlob((compressedBlob) => {
              this.compressedBlob = compressedBlob;
              const sizeKB = (compressedBlob.size / 1024).toFixed(1);
              
              this.changeUserHead = true;
              this.showCropper = false;
              Toast.success(`裁剪完成 (${sizeKB}KB)`);
            }, 'image/jpeg', 0.7);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(blob);
      });
    },
    onFakeUpload() {
      Toast('暂不支持文件上传，请联系客服');
    },

    // 提交逻辑
    onSaveDraft() {
      this.saveData(false);
    },
    onSubmit() {
      if (!this.checkInputData(this.customerInfoData)) return;
      this.saveData(true);
    },
     afterReadInsurance(file) {
      // 选择保险图片时：清空 PDF 列表，避免两边同时存在
      if (this.fileInsurancePdfList && this.fileInsurancePdfList.length) {
        this.fileInsurancePdfList = []
      }
      // 清空旧的已保存值，等待保存时重新上传并写回 URL
      this.customerInfoData.insuranceImg = ''
    },
    afterReadInsurancePDF(file) {
      // 选择保险 PDF 时：清空图片列表，避免两边同时存在
      if (this.fileInsuranceList && this.fileInsuranceList.length) {
        this.fileInsuranceList = []
      }
      this.customerInfoData.insuranceImg = ''
    },

    async uploadInsuranceImg(callback) {
      const urlStr = await this._uploadFromVantList(this.fileInsuranceList, { compressImage: true })
      this.customerInfoData.insuranceImg = urlStr
      console.log("上传文件uploadInsuranceImg:", this.customerInfoData.insuranceImg)
      this.fileInsuranceList = urlStr ? urlStr.split(',').filter(Boolean).map(url => ({ url })) : []
      if (callback) callback(urlStr)
      return urlStr
    },

    async uploadInsurancePDF(callback) {
      const urlStr = await this._uploadFromVantList(this.fileInsurancePdfList, { compressImage: false })
      this.customerInfoData.insuranceImg = urlStr
      console.log("上传文件uploadInsurancePDF:", this.customerInfoData.insuranceImg)
      this.fileInsurancePdfList = urlStr ? urlStr.split(',').filter(Boolean).map(url => ({ url })) : []
      if (callback) callback(urlStr)
      return urlStr
    },
        // 老页面同款核心上传器：识别 v-model 列表里的新增 file，上传后合并旧 url + 新 url
    async _uploadFromVantList(vantList, { compressImage }) {
      const list = Array.isArray(vantList) ? vantList : []

      // 1) 判断是否有新文件需要上传
      const newItems = list.filter(item => item && item.file)
      const hasNewFile = newItems.length > 0

      // 2) 如果没有新文件：直接返回当前 url（回显用）
      if (!hasNewFile) {
        return list
          .filter(item => item && item.url)
          .map(item => item.url)
          .join(',')
      }

      // 3) 需要上传：先保留旧 url（那些没有 file 的项）
      const keepUrls = list
        .filter(item => item && !item.file && item.url)
        .map(item => item.url)

      // 4) 组装 FormData
      const formData = new FormData()

      if (compressImage) {
        console.log("进入压缩图片了")
        // 图片压缩：入参是 File[]，回调给出 [{ file, name? }, ...]
        const rawFiles = newItems.map(item => item.file)
        const compressedList = await new Promise((resolve) => {
          compressorImageList(rawFiles, 2048, 2048, 0.6, (out) => resolve(out || []))
        })
        console.log("进入压缩图片了",compressedList)
        compressedList.forEach(v => {
          if (!v || !v.file) return
          if (v.name) formData.append('file', v.file, v.name)
          else formData.append('file', v.file)
        })
      } else {
        // PDF/其它文件：直接上传
        newItems.forEach(item => {
          if (!item || !item.file) return
          const f = item.file
          // 保持与老页面一致：有 name 用 name，没有就不传第三参
          if (f && f.name) formData.append('file', f, f.name)
          else formData.append('file', f)
        })
      }

      // 5) 上传（老页面同接口）
      const res = await request({
        url: '/Data/uploadFile?config=tripinsurance',
        method: 'post',
        data: formData
      })

      if (!res || !res.success) {
        // 兼容后端可能返回 message
        const msg = (res && (res.message || res.msg)) ? (res.message || res.msg) : '文件上传失败'
        throw new Error(msg)
      }

      const newUrls = Array.isArray(res.data) ? res.data.map(v => v && v.save).filter(Boolean) : []
      return [...keepUrls, ...newUrls].join(',')
    },

    checkInputData(data) {
      if (!data.loaclName) { MyNotify('info', '请输入中文姓名'); return false; }
      if (!data.lastName || !data.firstName) { MyNotify('info', '请输入拼音姓名'); return false; }
      if (!data.birthday) { MyNotify('info', '请选择生日'); return false; }

      if(this.baseSystem ==='cooldive'){
        if (!data.passportNumber) { MyNotify('info', '请输入护照号码'); return false; }
      }else{
         if (!data.idCardNumber) { MyNotify('info', '请输入身份证号码'); return false; }
      }

     
      if (!data.email) { MyNotify('info', '请输入邮箱'); return false; }
      if (!data.phone) { MyNotify('info', '请输入手机号'); return false; }
    
      
      if (!data.height || !data.weight || !data.shoeSize) { MyNotify('info', '请填写身体尺码'); return false; }

    
      if(!data.insuranceOrderId && this.baseSystem ==='cooldive'){
         if (!data.insuranceComplane || !data.insuranceCode || !data.insurancePhone) { MyNotify('info', '请填写潜水保险信息'); return false; }
      }
   
      if (this.needCert === 'certified') {
         if (!data.nowLicense || !data.totalDiving) { MyNotify('info', '请填写潜水证书信息'); return false; }
      }
      if (this.needCert) {

          if (!data.address || !data.postalCode || !data.country) { MyNotify('info', '请完善认证信息'); return false; }
          // 照片校验
          if (!this.option.img) { MyNotify('info', '请上传认证照片'); return false; }
      }
        if (!data.emergencyName || !data.emergencyContact) { MyNotify('info', '请填写紧急联系人'); return false; }

      return true;
    },

    async saveData(isSubmit,callback) {
      this.buttonLoading = true;
      // 保险可能是图片或 PDF（二选一）
      if (this.fileInsurancePdfList && this.fileInsurancePdfList.length > 0) {
        this.fileInsuranceList = []
        await this.uploadInsurancePDF()
      } else {
        this.fileInsurancePdfList = []
        await this.uploadInsuranceImg()
      }

      // 处理数据
      const payload = { ...this.customerInfoData };

      console.log("saveData:", payload)
      payload.useType = this.showType;
      payload.id = this.id;
      payload.studentId = this.value;
      // 如果是student模式，清空证书字段防止脏数据
      if (this.diverType === 'student') {
          payload.nowLicense = '';
          payload.totalDiving = '';
          payload.lastDiveDate = '';
      }

      // 如果修改了头像，需要把 base64 放到 data 字段中
      if (this.changeUserHead) {
        payload.data = this.option.img;
      } else {
        payload.data = undefined;
      }
      
      request({
        url: '/StoreHelper/updateCustomerInfo',
        method: 'post',
        data: payload
      }).then(res => {
        if(callback){
          callback();
        }
        this.buttonLoading = false;
        if (res.success) {
          MyNotify('success', isSubmit ? '提交成功' : '保存成功', 2000);
          this.visible = false;
          this.$emit('reload');
        }
      }).catch(() => {
        this.buttonLoading = false;
      });
    }
  }
}
</script>

<style scoped>
/* 强制全屏覆盖 */
.full-screen-popup {
  width: 100%;
  height: 100%;
  background-color: #F5F6FA;
}

.page-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #F5F6FA;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", Helvetica, sans-serif;
    color: #333;
}
.din-font { font-family: 'DIN Alternate', 'Roboto Condensed', sans-serif !important; }

.scroll-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 导航栏 */
.nav-header {
    background: white;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-bottom: 1px solid #F3F4F6;
    color: #111827;
    font-weight: 700;
    font-size: 17px;
    position: relative;
}
.nav-back {
    position: absolute;
    left: 16px;
    font-size: 20px;
    color: #374151;
    cursor: pointer;
}

/* 卡片 */
.form-card {
    background: white;
    border-radius: 12px;
    padding: 0 16px;
    margin: 16px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.03);
    overflow: hidden;
}
.section-title {
    padding: 16px 0 10px 0;
    font-size: 15px; font-weight: 700; color: #111827;
    display: flex; align-items: center; gap: 6px;
    border-bottom: 1px solid #F3F4F6;
    margin: 0 16px;
}
.section-title .van-icon { color: #0057FF; font-size: 16px; }

/* 提示 */
.tip-text {
    font-size: 12px; color: #D97706; background: #FFFBEB;
    padding: 8px 12px; border-radius: 6px; margin: 10px 16px 16px 16px;
    line-height: 1.4;
}
.tip-text.red { color: #B91C1C; background: #FEF2F2; display: flex; align-items: center; gap: 4px; }
.tip-text.blue { color: #1E40AF; background: #EFF6FF; text-align: justify; }

/* 性别选择 */
.gender-selector { display: flex; gap: 12px; padding: 16px; }
.gender-opt {
    flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px;
    padding: 10px; border-radius: 8px; border: 1px solid #E5E7EB;
    font-size: 14px; font-weight: 500; color: #6B7280; transition: all 0.2s;
}
.gender-opt.active-m { background: #EFF6FF; border-color: #0057FF; color: #0057FF; }
.gender-opt.active-f { background: #FDF2F8; border-color: #DB2777; color: #DB2777; }

/* 身体数据网格 */
.stats-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; padding: 16px; }
.stat-item {
    background: #F9FAFB; border-radius: 8px; padding: 10px;
    display: flex; flex-direction: column; gap: 6px;
}
.stat-label { font-size: 11px; color: #9CA3AF; display: flex; align-items: center; gap: 4px; }
.stat-input {
    border: none; background: transparent; width: 100%;
    font-size: 16px; font-weight: 700; color: #111827;
    font-family: 'DIN Alternate', sans-serif;
}

/* 履历切换 */
.exp-toggle { padding: 16px; display: flex; gap: 10px; }
.exp-toggle1 { padding: 16px; }
.toggle-btn {
    flex: 1; padding: 10px; text-align: center; border-radius: 8px;
    background: #F3F4F6; color: #6B7280; font-size: 14px; font-weight: 500;
}
.exp-toggle1 .toggle-btn{
  margin-top: 10px;
}
.toggle-btn.active { background: #0057FF; color: white; box-shadow: 0 4px 10px rgba(0, 87, 255, 0.2); }

/* 照片区域 */
.photo-wrapper { display: flex; flex-direction: column; align-items: center; padding: 24px 0; }
.photo-slot {
    width: 120px; height: 160px;
    background: #F3F4F6; border-radius: 8px; position: relative; overflow: hidden;
    box-shadow: inset 0 2px 6px rgba(0,0,0,0.05); display: flex; align-items: flex-end; justify-content: center;
}
.silhouette { font-size: 80px; color: #D1D5DB; margin-bottom: -10px; }
.preview-img { width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0; }
.camera-btn {
    position: absolute; bottom: 10px; right: 10px; width: 32px; height: 32px; border-radius: 50%;
    background: #0057FF; color: white; display: flex; align-items: center; justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 87, 255, 0.4); z-index: 10;
}
.reselect-mask {
    position: absolute; top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center;
    color: white; font-size: 12px; font-weight: 500; opacity: 0; transition: opacity 0.2s;
}
.photo-slot:active .reselect-mask { opacity: 1; }

.guide-row { display: flex; gap: 16px; margin-top: 20px; justify-content: center; }
.guide-item { display: flex; flex-direction: column; align-items: center; gap: 6px; font-size: 11px; color: #6B7280; }
.guide-icon {
    width: 36px; height: 36px; border-radius: 50%; background: #F9FAFB; border: 1px solid #E5E7EB;
    display: flex; align-items: center; justify-content: center; font-size: 18px;
}
.icon-no { color: #DC2626; background: #FEF2F2; border-color: #FECACA; }
.icon-yes { color: #059669; background: #ECFDF5; border-color: #A7F3D0; }

.upload-mini-box {
    width: 80px; height: 80px; background: #F9FAFB; border: 1px dashed #D1D5DB; border-radius: 8px;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 6px; color: #9CA3AF; font-size: 11px;
}

/* 底部栏 */
.bottom-bar {
    position: fixed; bottom: 0; left: 0; right: 0; background: white;
    padding: 12px 20px 30px 20px; box-shadow: 0 -4px 16px rgba(0,0,0,0.05);
    max-width: 480px; margin: 0 auto; z-index: 100; display: flex; gap: 12px;
}
.action-btn { flex: 1; height: 44px; border: none; border-radius: 22px; font-size: 15px; font-weight: 600; cursor: pointer; }
.action-btn.secondary { background: white; border: 1px solid #E5E7EB; color: #374151; }
.action-btn.primary { background: linear-gradient(135deg, #0057FF 0%, #0046CC 100%); color: white; box-shadow: 0 4px 12px rgba(0, 87, 255, 0.3); }

/* 裁剪器弹窗 */
.cropper-wrapper { height: 100%; display: flex; flex-direction: column; background: black; }
.cropper-content { flex: 1; overflow: hidden; position: relative; }
.cropper-footer { height: 60px; display: flex; align-items: center; justify-content: space-between; padding: 0 20px; background: black; color: white; }
.crop-cancel { font-size: 16px; color: #9CA3AF; }
.crop-tools { font-size: 14px; color: #fff; display: flex; align-items: center; gap: 4px; }
.crop-confirm { font-size: 16px; color: white; font-weight: 700; }

.card-header {
    display: flex; justify-content: space-between; align-items: center;
    margin-bottom: 12px; padding-bottom: 10px; border-bottom: 1px solid #F3F4F6;
}
.card-title {  margin: 0 16px;padding: 16px 0 10px 0;font-size: 15px; font-weight: 700; color: #111827; display: flex; align-items: center; gap: 6px;}

/* .section-title {
    padding: 16px 0 10px 0;
    font-size: 15px; font-weight: 700; color: #111827;
    display: flex; align-items: center; gap: 6px;
    border-bottom: 1px solid #F3F4F6;
    margin: 0 16px;
}
.section-title .van-icon { color: #0057FF; font-size: 16px; } */


.card-action { font-size: 13px; color: #0057FF; font-weight: 500; margin-top: 5px;}
</style>